import{useMemo}from"react";export const useBottomSheetSpringConfigs=configs=>useMemo((()=>configs),[configs]);